<button
  class="pill-tab-button"
  [ngStyle]="pillStyles | theme"
  (click)="onClick($event)"
  type="button"
>
  {{ label() }}
</button>
